export const SET_FAKE_CARDS = 'SET_FAKE_CARDS';
export const SET_NEW_COFFEE = 'SET_NEW_COFFEE';
export const SET_COFFEES = 'SET_COFFEES';
